<script setup lang="ts">
import type { Icons } from '@/components/base/BaseIcon.vue'

defineProps<{
  icon: Icons
  title: string
  deleteable?: boolean
}>()

const emit = defineEmits<{
  (e: 'delete'): void
}>()

const handleDelete = () => {
  emit('delete')
}
</script>

<template>
  <div class="mb-0 flex w-full flex-row pr-5">
    <div class="flex h-full flex-col items-center px-4">
      <div class="mt-[14px] flex min-h-7 w-7 items-center justify-center rounded-full border">
        <BaseIcon :stroke-width="1.5" :name="icon" class="h-4 w-4 text-foreground" />
      </div>
    </div>
    <div class="flex flex-1 flex-col" style="width: calc(100% - 60px)">
      <div class="mb-4 flex flex-col rounded-lg border bg-muted p-4">
        <div class="flex flex-col justify-stretch gap-3">
          <div class="flex flex-row justify-between items-center">
            <h3 class="text-sm font-medium text-foreground">{{ title }}</h3>
            <BaseIcon
              v-if="deleteable"
              name="HeroTrashIconOutline"
              class="h-5 w-5 cursor-pointer text-foreground-secondary hover:text-red-600"
              :stroke-width="1.5"
              @click="handleDelete"
            />
          </div>

          <div>
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
